import t from './story10.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,

  prose: [
    // Run 1 — the reported open: graphite's reach, China's 96%, and what the dust does.
    [{ text: t.s1P1 }, { text: t.s1P2 }, { text: t.s1P3 }, { text: t.s1P4 }],
    // Run 2 — resumes after the Liumao figure and the first pull quote: who Chávez is and
    // why the assignment still matters. Ends on the line that hands over to the interview.
    [{ text: t.s2P1 }, { text: t.s2P2 }, { text: t.s2P3 }],
    // Run 3 — the interview proper begins: Q1 and its two-paragraph answer.
    [{ text: t.s3P1 }, { text: t.s3P2 }, { text: t.s3P3 }],
    // Run 4 — Q2 and Q3 with their answers.
    [{ text: t.s4P1 }, { text: t.s4P2 }, { text: t.s4P3 }, { text: t.s4P4 }],
    // Run 5 — Q4: running into the factory, and the tail being followed a few days later.
    [{ text: t.s5P1 }, { text: t.s5P2 }, { text: t.s5P3 }],
    // Run 6 — resumes after the second pull quote: Q5, the shortest exchange in the piece.
    [{ text: t.s6P1 }, { text: t.s6P2 }],
    // Run 7 — the close: Q6, and how little is traceable a decade on.
    [{ text: t.s7P1 }, { text: t.s7P2 }, { text: t.s7P3 }],
  ],

  captions: [
    // 01 — hero, Lyu Shengwen and a day's worth of graphite dust, Mashan.
    [t.f1P1],
    // 02 — children playing in Liumao, below the BTR plant.
    [t.f2P1],
    // 03 — a farmer heading home from the rice fields outside Liumao.
    [t.f3P1],
    // 04 — a worker crossing the Jin Yang factory floor, Mashan.
    [t.f4P1],
    // 05 — Yu Zhen Jun washing his hands after planting corn.
    [t.f5P1],
    // 06 — graphite cargo bags stacked beside a Mashan factory.
    [t.f6P1],
  ],

  quotes: [
    {
      text: t.q1,
      attribution: t.q1Attr,
    },
    {
      text: t.q2,
      attribution: t.q2Attr,
    },
  ],
} as const
